import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class LayoutService {
  public rSidebarToggleStatus = false;
  public hmacEnabled = true;
  public navLayout = 'vertical';  
  public toggleStatus = false;     
  public themeLayout = 'box'; 
  public headerHeight = 160;
  public footerHeight = 56;
  public asidebarHeight =  window.innerHeight;
  public contentHeight = window.innerHeight - (this.headerHeight);
  public headerColorTheme = 'theme1';
  public leftHeaderColorTheme = 'theme2';
  public navbarColorTheme = 'theme2';
  public activeNavColorTheme = 'theme1';

  public collapsedLeftHeader = true;  
  public toggleOnHover = true;

  public defaultNavbar: string = "";   
  public toggleNavbar: string = "";     
  public navBarEffect: string = "";    
  public deviceType: string = "";      


  public defaultVerticalMenu = ['offcanvas', 'expanded', 'expanded'];



  public onToggleVerticalMenu = ['expanded', 'collapsed', 'collapsed'];
  public rsToggleStatus = new BehaviorSubject<boolean>(this.rSidebarToggleStatus);
  rsToggleStatusCast = this.rsToggleStatus.asObservable();


  public navBarMenuEffect = ['overlay', 'shrink', 'shrink'];

p

  public defaultDeviceType = ['mobile', 'tablet', 'desktop'];

  private setNavLayout = new BehaviorSubject<string>(this.navLayout);
  navLayoutCast = this.setNavLayout.asObservable();

  
  public selectedGroup = new Subject();
  public selectedRole = new BehaviorSubject<string>("");
  public leftPanel = new BehaviorSubject<boolean>(true);
  public nothingToDo = new BehaviorSubject<boolean>(false);


  private setCollapsedLeftHeader = new BehaviorSubject<boolean>(this.collapsedLeftHeader);
  collapsedLeftHeaderCast = this.setCollapsedLeftHeader.asObservable();

  private tStatus = new BehaviorSubject<boolean>(this.toggleStatus);
  tStatusCast = this.tStatus.asObservable();

  public HMACEnabled: BehaviorSubject<boolean> = new BehaviorSubject(this.hmacEnabled)

  private dfNavbar = new BehaviorSubject<string>(this.defaultNavbar);
  dfNavbarCast = this.dfNavbar.asObservable();

  private tNavbar = new BehaviorSubject<string>(this.toggleNavbar);
  toggleNavbarCast = this.tNavbar.asObservable();

  private nvEffect = new BehaviorSubject<string>(this.navBarEffect);
  nvEffectCast = this.nvEffect.asObservable();

  private setCtHeight = new BehaviorSubject<any>(this.contentHeight);
  contentHeightCast = this.setCtHeight.asObservable();

  private setAsidebarHeight = new BehaviorSubject<any>(this.asidebarHeight);
  setAsidebarHeightCast = this.setAsidebarHeight.asObservable();

  private setHeaderTheme = new BehaviorSubject<string>(this.headerColorTheme);
  headerThemeCast = this.setHeaderTheme.asObservable();

  private setLeftHeaderTheme = new BehaviorSubject<string>(this.leftHeaderColorTheme);
  leftHeaderThemeCast = this.setLeftHeaderTheme.asObservable();

  private setNavbarTheme = new BehaviorSubject<string>(this.navbarColorTheme);
  navbarThemeCast = this.setNavbarTheme.asObservable();

  private SetActiveNavTheme = new BehaviorSubject<string>(this.activeNavColorTheme);
  activeNavThemeCast = this.SetActiveNavTheme.asObservable();

  private SetThemeLayout = new BehaviorSubject<string>(this.themeLayout);
  themeLayoutCast = this.SetThemeLayout.asObservable();

  private appDeviceType = new BehaviorSubject<string>(this.deviceType);
  deviceTypeCast = this.appDeviceType.asObservable();

  public namesearchPanelStatus = new BehaviorSubject<boolean>(false);

  copyrightYear: BehaviorSubject<string> = new BehaviorSubject(
    new Date().getFullYear().toString()
  );

  constructor() {
  }

  closePanels(){
    this.namesearchPanelStatus.next(false);
  }

  getToggleStatus() {
    this.toggleStatus = !this.toggleStatus;
    this.tStatus.next(this.toggleStatus);
  }
  getDefaultNavbar(defaultNavbar: string) {
    this.dfNavbar.next(defaultNavbar);
  }
  getToggleNavbar(toggleNavbar: string) {
    this.tNavbar.next(toggleNavbar);
  }
  getNavBarEffect(navbarEffect: string) {
    this.nvEffect.next(navbarEffect);
  }
  getDeviceType(dt: string) {
    this.appDeviceType.next(dt);
  }

  getCopyrightYear(): Observable<string> {
    return this.copyrightYear.asObservable();
  }

  
  getThemeLayout(tl: string) {
    this.SetThemeLayout.next(tl);
  }
  getCollapsedLeftHeader(clh: boolean) {
    this.setCollapsedLeftHeader.next(clh);
  }
  getNavLayout(nl: string) {
    this.setNavLayout.next(nl);
  }
  getLeftHeaderThemeOnChange(themeName: string) {
    this.setLeftHeaderTheme.next(themeName);
  }
  getHeaderThemeOnChange(themeName: string) {
    this.setHeaderTheme.next(themeName);
  }
  getAsidebarThemeOnChange(themeName: string) {
    this.setNavbarTheme.next(themeName);
  }

  checkWindowWidth(windowWidth: number) {
    if (this.navLayout === 'vertical') {
      if (windowWidth >= 768 && windowWidth <= 1024) {
        this.defaultNavbar = this.defaultVerticalMenu[1];
        this.toggleNavbar = this.onToggleVerticalMenu[1];
        this.navBarEffect = this.navBarMenuEffect[1];
        this.deviceType = this.defaultDeviceType[1];
      } else if (windowWidth < 768) {
        this.defaultNavbar = this.defaultVerticalMenu[0];
        this.toggleNavbar = this.onToggleVerticalMenu[0];
        this.navBarEffect = this.navBarMenuEffect[0];
        this.deviceType = this.defaultDeviceType[0];
      } else {
        this.defaultNavbar = this.defaultVerticalMenu[2];
        this.toggleNavbar = this.onToggleVerticalMenu[2];
        this.navBarEffect = this.navBarMenuEffect[2];
        this.deviceType = this.defaultDeviceType[2];
      }
    } else if (this.navLayout === 'horizontal') {
      if (windowWidth >= 768 && windowWidth <= 1024) {
        this.deviceType = this.defaultDeviceType[1];
      } else if (windowWidth < 768) {
        this.deviceType = this.defaultDeviceType[0];
      } else {
        this.deviceType = this.defaultDeviceType[2];
      }
    }
    this.getDefaultNavbar(this.defaultNavbar);
    this.getToggleNavbar(this.toggleNavbar);
    this.getNavBarEffect(this.navBarEffect);
    this.getDeviceType(this.deviceType);
  }

  getVerticalNavbarOnWindowResize(windowWidth: number) {
    this.checkWindowWidth(windowWidth);
  }

}
